import './App.css';
import Home from './Sections/Home';
import Sorteio from './Sections/Sorteio';

function App() {
  return (
    <div className="App">
      <Home/>
      <Sorteio/>
    </div>
  );
}

export default App;
